import parseFNS from "date-fns/parse";

import { ru } from "date-fns/locale";
import setDefaultOptions from "date-fns/setDefaultOptions";
setDefaultOptions({ locale: ru });

type TPhpFormat = "Y-m-d" | "Y-m-d H:i" | "Y-m-d H:i:s";

export const parse = (dateString: string, phpFormat: TPhpFormat): Date => {
  switch (phpFormat) {
    case "Y-m-d":
      return parseFNS(dateString, "yyyy-MM-dd", new Date());

    case "Y-m-d H:i":
      return parseFNS(dateString, "yyyy-MM-dd HH:mm", new Date());

    case "Y-m-d H:i:s":
      return parseFNS(dateString, "yyyy-MM-dd HH:mm:ss", new Date());

    default:
      throw new Error(phpFormat);
  }
};
